import React, { Component } from 'react'
import "react-table/react-table.css";
import {CSVLink} from 'react-csv';
import moment from 'moment'
import { Link } from 'react-router-dom'

class Actions extends Component {

  render() {

    return (
      <div className="actions">
      <div className="action-items">
      <Link to={`/transactions/new`}><i className='fas fa-plus'/>
      &nbsp;Novo Registro</Link>&nbsp;&nbsp;&nbsp;
      <CSVLink data={this.props.transactions.map(x=>{
        return { ...x, data: moment(x.data).format('L'), valor: x.valor ? x.valor.toLocaleString('pt-BR') : 0 }
      })} target='_blank' filename={`registros-${this.props.selectedCompany}.csv`} >
      <i className='fas fa-download'/>&nbsp;Download CSV</CSVLink>
      </div>
      </div>
    );
  }
}

export default Actions;




// WEBPACK FOOTER //
// ./src/components/Actions.js